export enum ButtonVariations {
    whatsapp = 'buttonWhatsapp',
    whatsappProduct = 'buttonWhatsappProduct',
    download = 'buttonDownload',
    generic = 'buttonGeneric'
}
